import { render } from "./PreferredOJTLocationDialog.vue?vue&type=template&id=4fd8e626&scoped=true"
import script from "./PreferredOJTLocationDialog.vue?vue&type=script&lang=js"
export * from "./PreferredOJTLocationDialog.vue?vue&type=script&lang=js"

import "./PreferredOJTLocationDialog.vue?vue&type=style&index=0&id=4fd8e626&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fd8e626"]])

export default __exports__